import React, { memo } from "react"
import PropTypes from "prop-types"
import { TabPane } from "reactstrap"
import DateTabs from "components/weather/DateTabs"
import Chart from "components/weather/Chart"

import moment from "moment"
import { convertToMetric, numberFormatToMetric } from "helpers/string"

import { useSelector } from "react-redux"
import { dateHourlyForecastSelector, dateHourlyFormattedForecastSelector, forecastDateSelector } from "store/weather"

Pressure.propTypes = {
  className: PropTypes.string,
  params: PropTypes.shape({
    units: PropTypes.string.isRequired
  }).isRequired,
  onChangeFilters: PropTypes.func.isRequired
}
function Pressure({ className, params, onChangeFilters }) {
  const isConvertToMetric = params.units === "metric"

  const forecastDate = useSelector(forecastDateSelector)
  const hourlyForecast = useSelector(dateHourlyForecastSelector())
  const data = useSelector(dateHourlyFormattedForecastSelector("pressureMeanSeaLevel", "inches-of-mercury", 2, isConvertToMetric))

  if (!hourlyForecast) return null

  const currentTime = moment().format("HH:[00]")
  const currentTimePlusOne = moment().add(1, "hours").format("HH:[00]")
  const currentTimeData = hourlyForecast[currentTime] || hourlyForecast[currentTimePlusOne]

  const today = moment()
  const dateMoment = moment(forecastDate || today)
  const isToday = today.isSame(dateMoment, "day")
  const isTomorrow = today.clone().add(1, "day").isSame(dateMoment, "day")
  const dateFormatted = dateMoment.format(`${(isToday && "[Today], ") || (isTomorrow && "[Tomorrow], ") || ""}MMM DD, YYYY`)

  const classes = ["bg-white rounded px-40 py-30 position-relative overflow-hidden"]
  if (className) classes.push(className)

  return (
    <TabPane tabId="pressure" className={classes.join(" ")}>
      <div className="vstack gap-30">
        <DateTabs params={params} onChangeFilters={onChangeFilters} />
        <div className="mt-10">
          <p className="text-dark text-opacity-50 mb-1">{dateFormatted}</p>
          <p className="fs-3 m-0">
            {convertToMetric(
              currentTimeData?.pressureMeanSeaLevel,
              "inches-of-mercury",
              true,
              isConvertToMetric ? 0 : 2,
              isConvertToMetric
            )}
          </p>
        </div>
        <Chart
          hourlyData={data}
          color="58, 0, 180"
          fill
          yAxisKey="value"
          yFormatOptions={(value) =>
            numberFormatToMetric(
              parseFloat(value.toString().replace(/,/g, "")),
              "inches-of-mercury",
              isConvertToMetric ? 0 : 2,
              isConvertToMetric
            )
          }
        />
      </div>
    </TabPane>
  )
}

export default memo(Pressure)
